import api from './api';

const serviceRequestService = {
  getAll: async () => {
    const response = await api.get('/service-requests', { validateStatus: () => true });
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/service-requests/${id}`, { status }, { validateStatus: () => true });
    return response.data;
  },
};

export { serviceRequestService };

